"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findRule = exports.removeUnusedRules = exports.createSubsetAst = exports.scopeSelector = void 0;
const deprecated_selector_utils_1 = require("./deprecated-selector-utils");
const features_1 = require("../features");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const postcss = __importStar(require("postcss"));
/** new version scopeNestedSelector at selector.ts */
function scopeSelector(scopeSelectorRule, targetSelectorRule, rootScopeLevel = false) {
    const scopingSelectorAst = (0, deprecated_selector_utils_1.parseSelector)(scopeSelectorRule);
    const targetSelectorAst = (0, deprecated_selector_utils_1.parseSelector)(targetSelectorRule);
    const nodes = [];
    targetSelectorAst.nodes.forEach((targetSelector) => {
        scopingSelectorAst.nodes.forEach((scopingSelector) => {
            const outputSelector = (0, lodash_clonedeep_1.default)(targetSelector);
            outputSelector.before = scopingSelector.before || outputSelector.before;
            const first = outputSelector.nodes[0];
            const parentRef = first.type === 'invalid' && first.value === '&';
            const globalSelector = first.type === 'nested-pseudo-class' && first.name === 'global';
            const startsWithScoping = rootScopeLevel
                ? scopingSelector.nodes.every((node, i) => {
                    const o = outputSelector.nodes[i];
                    for (const k in node) {
                        if (node[k] !== o[k]) {
                            return false;
                        }
                    }
                    return true;
                })
                : false;
            if (first &&
                first.type !== 'spacing' &&
                !parentRef &&
                !startsWithScoping &&
                !globalSelector) {
                outputSelector.nodes.unshift(...(0, lodash_clonedeep_1.default)(scopingSelector.nodes), {
                    type: 'spacing',
                    value: ' ',
                });
            }
            (0, deprecated_selector_utils_1.traverseNode)(outputSelector, (node, i, nodes) => {
                if (node.type === 'invalid' && node.value === '&') {
                    nodes.splice(i, 1, ...(0, lodash_clonedeep_1.default)(scopingSelector.nodes));
                }
            });
            nodes.push(outputSelector);
        });
    });
    scopingSelectorAst.nodes = nodes;
    return {
        selector: (0, deprecated_selector_utils_1.stringifySelector)(scopingSelectorAst),
        selectorAst: scopingSelectorAst,
    };
}
exports.scopeSelector = scopeSelector;
/** new version createSubsetAst at rule.ts */
function createSubsetAst(root, selectorPrefix, mixinTarget, isRoot = false) {
    // keyframes on class mixin?
    const prefixType = (0, deprecated_selector_utils_1.parseSelector)(selectorPrefix).nodes[0].nodes[0];
    const containsPrefix = containsMatchInFirstChunk.bind(null, prefixType);
    const mixinRoot = mixinTarget ? mixinTarget : postcss.root();
    root.nodes.forEach((node) => {
        if (node.type === 'rule') {
            const ast = isRoot
                ? scopeSelector(selectorPrefix, node.selector, true).selectorAst
                : (0, deprecated_selector_utils_1.parseSelector)(node.selector);
            const matchesSelectors = isRoot
                ? ast.nodes
                : ast.nodes.filter((node) => containsPrefix(node));
            if (matchesSelectors.length) {
                const selector = (0, deprecated_selector_utils_1.stringifySelector)({
                    ...ast,
                    nodes: matchesSelectors.map((selectorNode) => {
                        if (!isRoot) {
                            (0, deprecated_selector_utils_1.fixChunkOrdering)(selectorNode, prefixType);
                        }
                        return destructiveReplaceNode(selectorNode, prefixType, {
                            type: 'invalid',
                            value: '&',
                        });
                    }),
                });
                mixinRoot.append(node.clone({ selector }));
            }
        }
        else if (node.type === 'atrule') {
            if (node.name === 'media' || node.name === 'supports') {
                const atRuleSubset = createSubsetAst(node, selectorPrefix, postcss.atRule({
                    params: node.params,
                    name: node.name,
                }), isRoot);
                if (atRuleSubset.nodes) {
                    mixinRoot.append(atRuleSubset);
                }
            }
            else if (isRoot) {
                mixinRoot.append(node.clone());
            }
        }
        else {
            // TODO: add warn?
        }
    });
    return mixinRoot;
}
exports.createSubsetAst = createSubsetAst;
function destructiveReplaceNode(ast, matchNode, replacementNode) {
    (0, deprecated_selector_utils_1.traverseNode)(ast, (node) => {
        if ((0, deprecated_selector_utils_1.isNodeMatch)(node, matchNode)) {
            node.type = 'selector';
            node.nodes = [replacementNode];
        }
    });
    return ast;
}
function containsMatchInFirstChunk(prefixType, selectorNode) {
    let isMatch = false;
    (0, deprecated_selector_utils_1.traverseNode)(selectorNode, (node) => {
        if (node.type === 'operator' || node.type === 'spacing') {
            return false;
        }
        else if (node.type === 'nested-pseudo-class') {
            return true;
        }
        else if ((0, deprecated_selector_utils_1.isNodeMatch)(node, prefixType)) {
            isMatch = true;
            return false;
        }
        return undefined;
    });
    return isMatch;
}
function removeUnusedRules(ast, meta, _import, usedFiles, resolvePath) {
    const isUnusedImport = !usedFiles.includes(_import.from);
    if (isUnusedImport) {
        const symbols = Object.keys(_import.named).concat(_import.defaultExport); // .filter(Boolean);
        ast.walkRules((rule) => {
            let shouldOutput = true;
            (0, deprecated_selector_utils_1.traverseNode)(rule.selectorAst, (node) => {
                // TODO: remove.
                if (symbols.includes(node.name)) {
                    return (shouldOutput = false);
                }
                const symbol = features_1.STSymbol.get(meta, node.name);
                if (symbol && (symbol._kind === 'class' || symbol._kind === 'element')) {
                    let extend = symbol[`-st-extends`] || symbol.alias;
                    extend = extend && extend._kind !== 'import' ? extend.alias || extend : extend;
                    if (extend &&
                        extend._kind === 'import' &&
                        !usedFiles.includes(resolvePath(meta.source, extend.import.from))) {
                        return (shouldOutput = false);
                    }
                }
                return undefined;
            });
            // TODO: optimize the multiple selectors
            if (!shouldOutput && rule.selectorAst.nodes.length <= 1) {
                rule.remove();
            }
        });
    }
}
exports.removeUnusedRules = removeUnusedRules;
function findRule(root, selector, test = (statement) => statement.prop === `-st-extends`) {
    let found = null;
    root.walkRules(selector, (rule) => {
        const declarationIndex = rule.nodes ? rule.nodes.findIndex(test) : -1;
        if (rule.isSimpleSelector && !!~declarationIndex) {
            found = rule.nodes[declarationIndex];
        }
    });
    return found;
}
exports.findRule = findRule;
//# sourceMappingURL=deprecated-stylable-utils.js.map